import { useState } from 'react';
import { useData } from '../context/DataContext';
import { contactAPI } from '../services/api';
import './Contact.css';

export default function Contact() {
  const { data } = useData();
  const company = data?.company || {};
  const faq = data?.faq || [];
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await contactAPI.submit(form);
      setSubmitted(true);
      setForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      alert('Failed to send message: ' + (err.response?.data?.detail || err.message));
    }
  };

  return (
    <main className="page contact-page">
      <div className="container">
        <div className="section-title">
          <span className="section-title__label">Reach Out</span>
          <h1 className="section-title__heading">Contact Us</h1>
          <p className="section-title__description">
            Have a question, project idea, or just want to say hello? We&apos;d love to hear from you.
          </p>
        </div>

        <div className="contact-page__grid">
          <div className="contact-page__form-section">
            {submitted ? (
              <div className="contact-page__success">
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. We&apos;ll get back to you shortly.</p>
              </div>
            ) : (
              <form className="contact-page__form" onSubmit={handleSubmit}>
                <div className="contact-page__row">
                  <div className="contact-page__field">
                    <label htmlFor="name">Full Name</label>
                    <input id="name" name="name" type="text" value={form.name} onChange={handleChange} required placeholder="Your name" />
                  </div>
                  <div className="contact-page__field">
                    <label htmlFor="email">Email Address</label>
                    <input id="email" name="email" type="email" value={form.email} onChange={handleChange} required placeholder="you@example.com" />
                  </div>
                </div>
                <div className="contact-page__field">
                  <label htmlFor="subject">Subject</label>
                  <input id="subject" name="subject" type="text" value={form.subject} onChange={handleChange} required placeholder="What's this about?" />
                </div>
                <div className="contact-page__field">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" name="message" rows="6" value={form.message} onChange={handleChange} required placeholder="Tell us more..." />
                </div>
                <button type="submit" className="btn btn--primary">Send Message</button>
              </form>
            )}
          </div>

          <div className="contact-page__info">
            <div className="contact-page__info-block">
              <h3>Email</h3>
              <p>{company.email}</p>
            </div>
            <div className="contact-page__info-block">
              <h3>Phone</h3>
              <p>{company.phone}</p>
            </div>
            <div className="contact-page__info-block">
              <h3>Address</h3>
              <p>{company.address}</p>
            </div>
            <div className="contact-page__info-block">
              <h3>Follow Us</h3>
              <div className="contact-page__socials">
                {Object.entries(company.social).map(([platform, url]) => (
                  <a key={platform} href={url} target="_blank" rel="noopener noreferrer" className="contact-page__social-link">
                    {platform.charAt(0).toUpperCase() + platform.slice(1)}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <section className="contact-page__faq">
          <h2 className="about-page__subtitle about-page__subtitle--center">Frequently Asked Questions</h2>
          <div className="contact-page__faq-list">
            {faq.map(item => (
              <div key={item.id} className={`contact-page__faq-item ${openFaq === item.id ? 'contact-page__faq-item--open' : ''}`}>
                <button className="contact-page__faq-question" onClick={() => setOpenFaq(openFaq === item.id ? null : item.id)}>
                  <span>{item.question}</span>
                  <span className="contact-page__faq-icon">{openFaq === item.id ? '−' : '+'}</span>
                </button>
                {openFaq === item.id && (
                  <div className="contact-page__faq-answer">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
